import { Navigate } from 'react-router-dom';
import { useSession } from '../features/auth';

interface PublicOnlyGuardProps {
  children: React.ReactNode;
}

export function PublicOnlyGuard({ children }: PublicOnlyGuardProps) {
  const { isAuthenticated } = useSession();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
